import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { FaSearch, FaAngleDoubleRight, FaBars, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";
import { IoNotifications, IoPersonCircleSharp, IoLogoWhatsapp,IoSearch  } from "react-icons/io5";
import axios from 'axios';
import { site_url, site_url_img } from "./../config.js";
import { Link } from "react-router-dom";
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import {  FaMapMarkedAlt , FaWhatsapp , FaPhoneAlt,FaArrowLeft   } from "react-icons/fa";

function Index() {
    const [categorydata, setcategorydata] = useState([]);

    const goBack = () => {
        window.history.back(); // Goes back to the previous page
      };


    useEffect(() => {
        const shopcategory = async () => {
          try {
            const response = await axios.get(site_url + '/vendor/shopcategory');
            if (response.data.status == 'success') {
              setcategorydata(response.data.category);
            }
          } catch (error) {
          }
        }
        
        shopcategory();
        
      }, [])



      
    return (
        <div>
               <Navbar expand="lg" className="navbar px-3">

<Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> All categories</center></Navbar.Brand>
<Nav className="ms-auto d-flex align-items-center">
</Nav>
</Navbar>
            <Container className="mt-3">
                <Row className="mt-4">
                    {categorydata.map((category, index) => (
                        <Col xs={4} key={index} className="mb-2">
                            <Link to={`/Shopcate`} state={{ category }}>
                                <center><img src={site_url_img + '/' + category.image} className="category_img" /></center>
                                <p className="category_text">{category.name}</p>
                            </Link>
                        </Col>
                    ))}
                </Row>
            </Container>
            <Footer />
  
        </div>
    )
}

export default Index